import request from '@/utils/request'

// 规格编码
export function apiBomProdLineAssignList (query) {
  return request({
    url: '/bom/bomProdLineAssign/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiBomProdLineAssignUpdate (data) {
  return request({
    url: '/bom/bomProdLineAssign',
    method: 'put',
    data: data
  })
}

// 新增
export function apiBomProdLineAssignAdd (data) {
  return request({
    url: '/bom/bomProdLineAssign',
    method: 'post',
    data: data
  })
}

// 车间编码
export function apiBomWorkshopFindList (query) {
  return request({
    url: '/bom/bomWorkshop/findList',
    method: 'get',
    params: query
  })
}

// 工序编码
export function apiBomOperationFindList (query) {
  return request({
    url: '/bom/bomOperation/findList',
    method: 'get',
    params: query
  })
}

// 工艺路线-保存
export function apiBomProdLineAssignEditBomRoutingProduct (data) {
  return request({
    url: '/bom/bomProdLineAssign/editBomRoutingProduct',
    method: 'put',
    data: data
  })
}

// 工艺路线
export function apiBomRoutingHeaderFindList (query) {
  return request({
    url: `/bom/bomRoutingHeader/findList`,
    method: 'get',
    params: query
  })
}

// 详情-标准工艺路线
export function apiBomRoutingHeaderId (id) {
  return request({
    url: `/bom/bomRoutingHeader/${id}`,
    method: 'get'
  })
}
